/**
 * @file src/_modulos/prenota/tabela/layouts/config/api/integration.ts
 * @description Integração simplificada entre filtros e API
 *
 * Princípios aplicados:
 * - KISS: Lógica simples e direta
 * - SRP: Apenas integra filtros com API
 * - YAGNI: Remove hooks não utilizados
 */

"use client";

import { useMemo } from "react";
import {
  buildApiPayload,
  type UsePrenotasOptions,
  useTableStore,
} from "@PN/tabela";

/* -------------------------------------------------------------------------- */
/* HOOK PRINCIPAL                                                             */
/* -------------------------------------------------------------------------- */

/**
 * Hook para construir payload da API
 */
export function useApiPayload(options: UsePrenotasOptions) {
  const { activeTab, appliedFilters, selectedFilials, sorting, searchField } =
    useTableStore();

  return useMemo(() => {
    const { page = 1, pageSize = 10, searchTerm } = options;

    return buildApiPayload(
      appliedFilters,
      activeTab,
      selectedFilials,
      sorting,
      page,
      pageSize,
      searchTerm,
      searchField
    );
  }, [appliedFilters, activeTab, selectedFilials, sorting, searchField, options]);
}
